//-------------------------------------------------------------------------------------------------- Imports
import { useDispatch, useSelector } from "react-redux";
import { StyleSheet } from "../../StyleSheet";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { getMobilePhoneData } from "../../stores/slices/mobilePhoneSlice";
import { useCallback, useEffect, useState } from "react";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import InfoCardComponent from "../../components/InfoCardComponent";
import { ResponseMobilePhoneDataMobilePhone } from "../../types/common";
import { Col, Row } from "antd";
import PhonesList, { OnClickElementProps } from "./components/PhonesList";
import DataUsage from "./components/DataUsage";
import MobileRecharges from "./components/MobileRecharges";
import { getTrackingMegamovilData } from "../../stores/slices/megamovilTrackingSlice";
import { Status } from "../../components/ModalConfirmationSlice";
import { clearStatusConfirmation, setSatusConfirmation } from "../../stores/slices/statusConfirmationSlice";

//-------------------------------------------------------------------------------------------------- View
const MobileTelephony = () => {
    const { selectedContract } = useSelector(getGeneralData);
    const mobileTelephony = useSelector(getMobilePhoneData);
    const megaMovilTracking = useSelector(getTrackingMegamovilData);
    // Data
    const [clientId, setClientId] = useState<string>("");
    const [selectedItem, setSelectedItem] = useState<OnClickElementProps>();
    const [selectedPhone, setSelectedPhone] = useState<string>("");
    const [phones, setPhones] = useState<ResponseMobilePhoneDataMobilePhone[]>([]);
    // Control
    const [withMobilTelephony, setWithMobilTelephony] = useState<boolean>(false);
    const [viewToRender, setViewToRender] = useState<number>(0);
    const dispatch = useDispatch();

    const handleClickDetailList = useCallback((data: OnClickElementProps) => {
        setSelectedItem(data);
        setViewToRender(1);
    }, []);

    const handleClickRechargeList = useCallback((data: string) => {
        setSelectedPhone(data);
        setViewToRender(2);
    }, []);

    const returnFunction = useCallback(() => {
        setViewToRender(0);
        setSelectedPhone("")
        setSelectedItem(undefined);
    }, []);

    useEffect(() => {
        if (selectedContract) {
            setViewToRender(0);
            setClientId(selectedContract.sucursal + selectedContract.suscriptor);
        }
    }, [selectedContract]);

    useEffect(() => {
        if (clientId && mobileTelephony && clientId === mobileTelephony.clientId) {
            setWithMobilTelephony(mobileTelephony.hasCellPhone);
            setPhones(mobileTelephony.mobilePhones);
        }
    }, [clientId, mobileTelephony]);

    useEffect(() => {
        if (clientId && megaMovilTracking && clientId === megaMovilTracking.clientId && megaMovilTracking.status === true) {
            dispatch(setSatusConfirmation({
                textAnts: "Estimado Usuario",
                subtitle: `Le informamos el estado de su contratación realizada el día`,
                date: megaMovilTracking.fecha,
                text: "de su Mega móvil",
                plan: megaMovilTracking.paquete,
                state: megaMovilTracking.estadoContratacion,
                visible: true,
                status: Status.SUCCESS,
            }));
        } else {
            dispatch(clearStatusConfirmation());
        }
    }, [clientId, megaMovilTracking, dispatch]);

    return (
        <SubDefaultLayout
            title={(viewToRender === 0) ? ("Telefonía Móvil") : (viewToRender === 1) ? ("Detalle de Línea") : ("Recargas")}
            needReturn={viewToRender !== 0}
            functionReturn={returnFunction}
        >
            {megaMovilTracking.status === true ? (
                <InfoCardComponent
                    title={megaMovilTracking.estadoContratacion}
                    description={megaMovilTracking.message}
                    color="#FFEAD2"
                    colorText="#FE8802" />
            ) : null}
            <Row style={styles.mainContainer}>
                {(!withMobilTelephony) ? (
                    <InfoCardComponent
                        title="¡Estimado Suscriptor!"
                        description="Por el momento no hay información disponible. No hay teléfonos."
                    />
                ) : ((viewToRender === 0) ? (
                    <Col sm={24} md={12}>
                        <PhonesList
                            phonesList={phones}
                            onDetailClickElement={handleClickDetailList}
                            onRechargeClickElement={handleClickRechargeList}
                        />
                    </Col>
                ) : ((viewToRender === 1) ? (
                    <Col sm={24} lg={24} xl={18}>
                        <DataUsage name={selectedItem?.name} phone={selectedItem?.phone} clientId={clientId} />
                    </Col>
                ) : (
                    <Col sm={24}>
                        <MobileRecharges clientData={selectedContract} phone={selectedPhone} setViewToRender={setViewToRender} />
                    </Col>
                )))}
            </Row>
        </SubDefaultLayout>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        width: "100%",
        justifyContent: "center",
        marginTop: 40,
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default MobileTelephony;
